export const FaceBook = [

    {
        type: "Facebook",
        name: "Vegan Los Angeles",
        category: "FaceBook Group",
        author: "",
        description: "",
        link: "https://www.facebook.com/groups/Vegan.Los.Angeles/",
    },
    {
        type: "Facebook",
        name: "Vegan Boston Massachusetts",
        category: "FaceBook Group",
        author: "",
        description: "",
        link: "https://www.facebook.com/groups/Vegan.Boston.Massachusetts/",
    },
    {
        type: "Facebook",
        name: "Vegan Houston",
        category: "FaceBook Group",
        author: "",
        description: "",
        link: "https://www.facebook.com/groups/Vegan.Houstin.TX/",
    },
    {
        type: "Facebook",
        name: "Vegan Denver Colorado",
        category: "FaceBook Group",
        author: "",
        description: "",
        link: "https://www.facebook.com/groups/Vegan.Denver.Colorado/",
    },
    {
        type: "Facebook",
        name: "Vegan Colorado Springs CO",
        category: "FaceBook Group",
        author: "",
        description: "",
        link: "https://www.facebook.com/groups/Vegan.Colorado.Springs.CO/",
    },
    {
        type: "Facebook",
        name: "Vegan Minneapolis MN",
        category: "FaceBook Group",
        author: "",
        description: "",
        link: "https://www.facebook.com/groups/Vegan.Minneapolis.MN/",
    },
    {
        type: "Facebook",
        name: "Vegan Washington DC",
        category: "FaceBook Group",
        author: "",
        description: "",
        link: "https://www.facebook.com/groups/Vegan.Minneapolis.MN/",
    },
    {
        type: "Facebook",
        name: "Vegan Las Vegas",
        category: "FaceBook Group",
        author: "",
        description: "",
        link: "https://www.facebook.com/groups/Vegan.Minneapolis.MN/",
    },
    {
        type: "Facebook",
        name: "Vegan Atlanta GA",
        category: "FaceBook Group",
        author: "",
        description: "",
        link: "https://www.facebook.com/groups/Vegan.Minneapolis.MN/",
    },
    {
        type: "Facebook",
        name: "Vegan San Antonio TX",
        category: "FaceBook Group",
        author: "",
        description: "",
        link: "https://www.facebook.com/groups/Vegan.Minneapolis.MN/",
    },
    {
        type: "Facebook",
        name: "Vegan Miami FL",
        category: "FaceBook Group",
        author: "",
        description: "",
        link: "https://www.facebook.com/groups/Vegan.Miami.FL/",
    },
    {
        type: "Facebook",
        name: "Vegan Charlotte NC",
        category: "FaceBook Group",
        author: "",
        description: "",
        link: "https://www.facebook.com/groups/Vegan.Charlotte.NC/",
    },
    {
        type: "Facebook",
        name: "Vegan Raleigh NC",
        category: "FaceBook Group",
        author: "",
        description: "",
        link: "https://www.facebook.com/groups/Vegan.Raleigh.NC/",
    },
    {
        type: "Facebook",
        name: "Vegan Omaha NE",
        category: "FaceBook Group",
        author: "",
        description: "",
        link: "https://www.facebook.com/groups/Vegan.Omaha.NE/",
    },
    {
        type: "Facebook",
        name: "Vegan Louisville KY",
        category: "FaceBook Group",
        author: "",
        description: "",
        link: "https://www.facebook.com/groups/Vegan.Omaha.NE/",
    },
    {
        type: "Facebook",
        name: "Vegan Phoenix AZ",
        category: "FaceBook Group",
        author: "",
        description: "",
        link: "https://www.facebook.com/groups/Vegan.Phoenix.AZ/",
    },
];
